import { useState } from "react";
import "./promo.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { FeedbackModal } from "../../../../components/landing/modals/FeedbackModal/FeedbackModal";
import { RibbonMarquee } from "../../../../components/landing/ui/RibbonMarquee/RibbonMarquee";

export const Promo = () => {
  const data = useHomeContent();
  const [open, setOpen] = useState(false);

  if (!data?.promo) return null;
  const p = data.promo;
  const feedbackModal = data.feedbackModal ?? {};

  return (
    <>
      <section className="oc-promo oc-section">
        <div className="oc-container">
          <div className="oc-promo__card">
            <div className="oc-promo__ribbons" aria-hidden="true">
              <RibbonMarquee
                text={p.ribbonText ?? ""}
                speedSec={40}
                direction="right"
                className="oc-promo__ribbon oc-promo__ribbon--st1"
              />
              <RibbonMarquee
                text={p.ribbonText ?? ""}
                speedSec={40}
                direction="right"
                className="oc-promo__ribbon oc-promo__ribbon--st2"
              />
              <RibbonMarquee
                text={p.ribbonText ?? ""}
                speedSec={40}
                direction="right"
                className="oc-promo__ribbon oc-promo__ribbon--st3"
              />
              <RibbonMarquee
                text={p.ribbonText ?? ""}
                speedSec={40}
                direction="left"
                className="oc-promo__ribbon oc-promo__ribbon--st4"
              />
              <RibbonMarquee
                text={p.ribbonText ?? ""}
                speedSec={40}
                direction="left"
                className="oc-promo__ribbon oc-promo__ribbon--st5"
              />
            </div>

            <div className="oc-promo__content">
              <h3
                className="oc-promo__title"
                dangerouslySetInnerHTML={{ __html: p.title }}
              />
              <div
                className="oc-promo__desc"
                dangerouslySetInnerHTML={{ __html: p.description }}
              />

              <button
                type="button"
                className="oc-promo__btn"
                onClick={() => setOpen(true)}
              >
                {p.buttonText ?? data?.common?.send ?? ""}
              </button>
            </div>
          </div>
        </div>
      </section>

      <FeedbackModal
        open={open}
        onClose={() => setOpen(false)}
        title={p.feedbackModalTitle ?? feedbackModal.title}
        thanksText={p.feedbackModalThanksText ?? feedbackModal.thanksText}
        submitLabel={p.feedbackModalSubmitLabel ?? feedbackModal.submitLabel}
        formCopy={data.feedbackForm}
      />
    </>
  );
};
